import React, {useRef, useState, useEffect} from "react";
import {Link} from "react-router-dom"
import PropTypes from 'prop-types'
//import './style.scss'

const Button = (props) => {

  const {
    onClick = null,
    onMouseEnter,
    onMouseLeave,
    label = 'Button Label',
    disabled = false,
    className = null,
    link = null,
    linkState = null,
    linkOutside = null,
    icon = null,
    iconSize = null,
    target = null,
    style = {},
    fullWidth = false,
    iconReversed = false,
    justifyContent = 'center',
    size = 'm',
    color = 'green',
    children,
    debounce = 0, // debounce in ms, default 0 = no debounce
  } = props

  const [isDebounced, setIsDebounced] = useState(false);
  const debounceTimeout = useRef(null);

  useEffect(() => {
    return () => {
      if (debounceTimeout.current) clearTimeout(debounceTimeout.current);
    };
  }, []);

  /**
   * scenarios:
   * - <a> (external)
   * - <Link> (internal)
   * - <button> onClick/no link
   *
   * props
   * - multiple icons: hover and normal
   * - icon alignment: left, right, center (when no label)
   * - disabled
   * - link
   * - onClick (function callback)
   * - className: small, medium, large, colors: red-green-yellow-orange, style: ghost, solid, shadow/no shadow
   * - linkState
   * - style
   * - target
   *
   */
  const clickHandler = (e) => {
    e.preventDefault();
    if (isDebounced || disabled) return;

    if (debounce > 0) {
      setIsDebounced(true);
      debounceTimeout.current = setTimeout(() => setIsDebounced(false), debounce);
    }

    onClick && onClick(e);
  };

  const getStyle = () => {
    if (justifyContent){
      return Object.assign({}, {justifyContent:justifyContent} , style)
    } else {
      return style
    }
  }

  const getClassName = () => {
    let string = "component-button  "
    if (className) {
      string = "component-button " + className
    }
    if (disabled || isDebounced) {
      string += " disabled ";
    }
    if (fullWidth) {
      string += " btn-full-width "
    }
    if (iconReversed) {
      string += " btn-icon-reversed "
    }
    if (size) {
      string += " btn-size-" + size
    }
    if (color) {
      string += " btn-color-" + color
    }
    if (children){
      string += " with-children "
    }
    return string
  }

  return (
    <>
      {linkOutside &&
        <a
          className={getClassName()}
          style={getStyle()}
          href={linkOutside}
          target={target}
          title={label}
          onClick={(disabled || isDebounced) ? e => e.preventDefault() : undefined}
          onMouseEnter={onMouseEnter}
          onMouseLeave={onMouseLeave}
        >
          {icon && <img src={icon} width={iconSize} alt={label}/>}
          {label}
          {children && children}
        </a>
      }

      {link &&
        <Link
          className={getClassName()}
          to={disabled || isDebounced ? null : link}
          style={getStyle()}
          state={linkState}
          target={target}
          disabled={disabled || isDebounced}
          onMouseEnter={onMouseEnter}
          onMouseLeave={onMouseLeave}
          onClick={disabled || isDebounced ? e => e.preventDefault() : undefined}
        >
          {icon && <img src={icon} width={iconSize} alt={label}/>}
          {label}
          {children && children}
        </Link>
      }

      {(onClick || (!linkOutside && !link)) &&
        <button
          className={getClassName()}
          onClick={(!disabled && !isDebounced && onClick) ? clickHandler : undefined}
          type="button"
          style={getStyle()}
          disabled={disabled || isDebounced}
          onMouseEnter={onMouseEnter}
          onMouseLeave={onMouseLeave}
        >
          {icon && <img src={icon} width={iconSize} alt={label}/>}
          {label}
          {children && children}
        </button>
      }
    </>
  )
}

Button.propTypes = {
  label: PropTypes.string,
  link: PropTypes.string,
  style: PropTypes.object,
  linkState: PropTypes.object,
  onClick: PropTypes.func,
  class: PropTypes.string,
  disabled: PropTypes.bool,
  linkOutside: PropTypes.string,
  // icon: PropTypes,
  iconSize: PropTypes.number,
  target: PropTypes.string,
  fullWidth: PropTypes.bool,
  iconReversed: PropTypes.bool,
  justifyContent: PropTypes.string,
  size: PropTypes.string,
  color: PropTypes.string,
  debounce: PropTypes.number,
}

export default Button
